import logisticGroupsService from "../shared/services/logisticGroupsService";

const REQUEST_LOGISTIC_GROUPS = "REQUEST_LOGISTIC_GROUPS";
const RESPONSE_LOGISTIC_GROUPS = "RESPONSE_LOGISTIC_GROUPS";
const REQUEST_LOGISTIC_GROUPS_FAILURE = "REQUEST_LOGISTIC_GROUPS_FAILURE";

const requestlogisiticGroupsAction = () => {
  return {
    type: REQUEST_LOGISTIC_GROUPS,
  };
};

const responselogisiticGroupsAction = (data) => {
  return {
    type: RESPONSE_LOGISTIC_GROUPS,
    data,
  };
};

const requestlogisiticGroupsFailureAction = (errors) => {
  return {
    type: REQUEST_LOGISTIC_GROUPS_FAILURE,
    errors,
  };
};

const getlogisiticGroups = (options = {}) => {
  return (dispatch) => {
    dispatch(requestlogisiticGroupsAction());

    logisticGroupsService
      .getLogisticGroups(options)
      .then((result) => {
        dispatch(responselogisiticGroupsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestlogisiticGroupsFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_LOGISTIC_GROUPS = "REQUEST_CREATE_LOGISTIC_GROUPS";
const RESPONSE_CREATE_LOGISTIC_GROUPS = "RESPONSE_CREATE_LOGISTIC_GROUPS";
const REQUEST_CREATE_LOGISTIC_GROUPS_FAILURE = "REQUEST_CREATE_LOGISTIC_GROUPS_FAILURE";

const requestCreateLogisiticGroupsAction = () => {
  return {
    type: REQUEST_CREATE_LOGISTIC_GROUPS,
  };
};

const responseCreateLogisiticGroupsAction = (data) => {
  return {
    type: RESPONSE_CREATE_LOGISTIC_GROUPS,
    data,
  };
};

const requestCreateLogisiticGroupsFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_LOGISTIC_GROUPS_FAILURE,
    errors,
  };
};

const createLogisiticGroups = (options) => {
  return (dispatch) => {
    dispatch(requestCreateLogisiticGroupsAction());

    logisticGroupsService
      .createLogisticGroup(options)
      .then((result) => {
        options.id = result.data.id;
        options.controlPoints = [];

        dispatch(responseCreateLogisiticGroupsAction(options));
      })
      .catch((error) => {
        dispatch(requestCreateLogisiticGroupsFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_LOGISTIC_GROUPS = "REQUEST_DELETE_LOGISTIC_GROUPS";
const RESPONSE_DELETE_LOGISTIC_GROUPS = "RESPONSE_DELETE_LOGISTIC_GROUPS";
const REQUEST_DELETE_LOGISTIC_GROUPS_FAILURE = "REQUEST_DELETE_LOGISTIC_GROUPS_FAILURE";

const requestDeleteLogisiticGroupsAction = () => {
  return {
    type: REQUEST_DELETE_LOGISTIC_GROUPS,
  };
};

const responseDeleteLogisiticGroupsAction = (data) => {
  return {
    type: RESPONSE_DELETE_LOGISTIC_GROUPS,
    data,
  };
};

const requestDeleteLogisiticGroupsFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_LOGISTIC_GROUPS_FAILURE,
    errors,
  };
};

const deleteLogisiticGroups = (options) => {
  return (dispatch) => {
    dispatch(requestDeleteLogisiticGroupsAction());

    logisticGroupsService
      .deleteLogisticGroup(options)
      .then((result) => {
        dispatch(responseDeleteLogisiticGroupsAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteLogisiticGroupsFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_CP_LOGISTIC_GROUPS = "REQUEST_CREATE_CP_LOGISTIC_GROUPS";
const RESPONSE_CREATE_CP_LOGISTIC_GROUPS = "RESPONSE_CREATE_CP_LOGISTIC_GROUPS";
const REQUEST_CREATE_CP_LOGISTIC_GROUPS_FAILURE = "REQUEST_CREATE_CP_LOGISTIC_GROUPS_FAILURE";

const requestCreateCPLogisiticGroupsAction = () => {
  return {
    type: REQUEST_CREATE_CP_LOGISTIC_GROUPS,
  };
};

const responseCreateCPLogisiticGroupsAction = (controlPoint, group) => {
  return {
    type: RESPONSE_CREATE_CP_LOGISTIC_GROUPS,
    controlPoint,
    group,
  };
};

const requestCreateCPLogisiticGroupsFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_CP_LOGISTIC_GROUPS_FAILURE,
    errors,
  };
};

const createControlPointLogisiticGroups = (controlPoint, group) => {
  return (dispatch) => {
    dispatch(requestCreateCPLogisiticGroupsAction());

    logisticGroupsService
      .createControlPointLogisticGroup({ controlPointId: controlPoint.id, logisticGroupId: group.id })
      .then((result) => {
        dispatch(responseCreateCPLogisiticGroupsAction(controlPoint, group));
      })
      .catch((error) => {
        dispatch(requestCreateCPLogisiticGroupsFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_CP_LOGISTIC_GROUPS = "REQUEST_DELETE_CP_LOGISTIC_GROUPS";
const RESPONSE_DELETE_CP_LOGISTIC_GROUPS = "RESPONSE_DELETE_CP_LOGISTIC_GROUPS";
const REQUEST_DELETE_CP_LOGISTIC_GROUPS_FAILURE = "REQUEST_DELETE_CP_LOGISTIC_GROUPS_FAILURE";

const requestDeleteCPLogisiticGroupsAction = () => {
  return {
    type: REQUEST_DELETE_CP_LOGISTIC_GROUPS,
  };
};

const responseDeleteCPLogisiticGroupsAction = (controlPoint) => {
  return {
    type: RESPONSE_DELETE_CP_LOGISTIC_GROUPS,
    controlPoint,
  };
};

const requestDeleteCPLogisiticGroupsFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_CP_LOGISTIC_GROUPS_FAILURE,
    errors,
  };
};

const deletelControlPointLogisiticGroups = (controlPoint, group) => {
  return (dispatch) => {
    dispatch(requestDeleteCPLogisiticGroupsAction());

    logisticGroupsService
      .deleteCreateControlPointLogisticGroup({ controlPointId: controlPoint.id, logisticGroupId: group.id })
      .then((result) => {
        dispatch(responseDeleteCPLogisiticGroupsAction(controlPoint));
      })
      .catch((error) => {
        dispatch(requestDeleteCPLogisiticGroupsFailureAction(error.response));
      });
  };
};

const SELECT_LOGISTIC_GROUPS = "SELECT_LOGISTIC_GROUPS";

const selectLogisticGroupAction = (data) => {
  return {
    type: SELECT_LOGISTIC_GROUPS,
    data,
  };
};

const selectLogisticGroup = (data) => {
  return (dispatch) => {
    dispatch(selectLogisticGroupAction(data));
  };
};

export {
  REQUEST_LOGISTIC_GROUPS,
  RESPONSE_LOGISTIC_GROUPS,
  REQUEST_LOGISTIC_GROUPS_FAILURE,
  getlogisiticGroups,
  REQUEST_CREATE_LOGISTIC_GROUPS,
  RESPONSE_CREATE_LOGISTIC_GROUPS,
  REQUEST_CREATE_LOGISTIC_GROUPS_FAILURE,
  createLogisiticGroups,
  REQUEST_DELETE_LOGISTIC_GROUPS,
  RESPONSE_DELETE_LOGISTIC_GROUPS,
  REQUEST_DELETE_LOGISTIC_GROUPS_FAILURE,
  deleteLogisiticGroups,
  REQUEST_CREATE_CP_LOGISTIC_GROUPS,
  RESPONSE_CREATE_CP_LOGISTIC_GROUPS,
  REQUEST_CREATE_CP_LOGISTIC_GROUPS_FAILURE,
  createControlPointLogisiticGroups,
  REQUEST_DELETE_CP_LOGISTIC_GROUPS,
  RESPONSE_DELETE_CP_LOGISTIC_GROUPS,
  REQUEST_DELETE_CP_LOGISTIC_GROUPS_FAILURE,
  deletelControlPointLogisiticGroups,
  SELECT_LOGISTIC_GROUPS,
  selectLogisticGroup,
};
